import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ArrowLeft, Loader2 } from "lucide-react";
import { updateCustomers } from "@/services/auth";
import { useTranslation } from "react-i18next";

export default function SloganPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);
  const [slogan, setSlogan] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [error, setError] = useState("");
  const customerCode = localStorage.getItem("customercode");
  const { data: customer } = useSelector((state) => state.customer);
  const handleSubmit = async () => {
    if (!slogan.trim()) {
      setError("slogan.enterSlogan");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const res = await updateCustomers(token, customerCode, { slogan: slogan.trim() });
      if (res) {
        setShowPopup(true);
      } else {
        setError("common.somethingWrong");
      }
    } catch (err) {
      setError("common.somethingWrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F6FA] flex justify-center">
      <div className="w-full max-w-md bg-white min-h-screen md:rounded-3xl md:shadow-lg">
        <div className="relative flex items-center justify-center border-b border-gray-100 px-4 py-4">
          <button
            onClick={() => navigate(-1)}
            className="absolute left-4 w-9 h-9 flex items-center justify-center rounded-full"
            style={{ backgroundColor: "#1A1F3610" }}
          >
            <ArrowLeft className="w-5 h-5 text-[#1A1F36]" />
          </button>

          <p className="text-base font-semibold text-[#1A1F36]">
            {t("slogan.title")}
          </p>
        </div>

        {customer?.customer?.slogan ? (
          <div className="bg-gradient-to-br from-green-50 to-white border border-green-100 rounded-2xl p-5 shadow-sm">

            {/* Icon */}
            <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center mb-3 mx-auto">
              <span className="text-green-600 text-xl">🏆</span>
            </div>

            {/* Title */}
            <p className="text-base font-semibold text-center mb-1" style={{ color: "#1A1F36" }}>
              {t("slogan.contestSubmitted")}
            </p>

            {/* Description */}
            <p className="text-sm text-gray-500 text-center leading-relaxed mb-4">
              {t("slogan.contestDesc1")}{" "}<span className="font-semibold text-[#1A1F36]"> {t("slogan.grandPrize")}</span>.
              {t("slogan.contestDesc2")}
              {t("slogan.contestDesc3")}
            </p>

            {/* Badge */}


          </div>
        ) : (
          <div className="flex-1 px-6 pt-10 flex flex-col gap-5">

            <div className="text-center mb-2">
              <div
                className="w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4"
                style={{ backgroundColor: '#1A1F36' }}
              >
                <span className="text-2xl">✏️</span>
              </div>
              <h2 className="text-xl font-bold" style={{ color: '#1A1F36' }}>  {t("slogan.enterSloganTitle")}</h2>
              <p className="text-sm text-gray-400 mt-1">
                {t("slogan.enterSloganDesc")}
              </p>
            </div>

            {/* Input */}
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium" style={{ color: '#1A1F36' }}> {t("slogan.yourSlogan")}</label>
              <textarea
                rows={4}
                value={slogan}
                onChange={(e) => { setSlogan(e.target.value); setError(""); }}
                placeholder={t("slogan.sloganPlaceholder")}
                className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-700 resize-none focus:outline-none focus:ring-2 focus:ring-[#1A1F36] transition"
              />
              {error && <p className="text-xs text-red-500 mt-1">{t(error)}</p>}
            </div>

            {/* Submit Button */}
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="w-full text-white py-3 rounded-xl text-sm font-semibold shadow-md active:scale-95 transition-all flex items-center justify-center gap-2 disabled:opacity-70"
              style={{ backgroundColor: '#1A1F36' }}
            >
              {loading ? (
                <>
                  <Loader2 className="animate-spin h-4 w-4" />
                  {t("slogan.submitting")}
                </>
              ) : (
                t("slogan.submitSlogan")
              )}
            </button>
          </div>
        )}
      </div>

      {/* Thank You Popup */}
      {showPopup && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 px-6">
          <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-sm text-center animate-fade-in">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl">🎉</span>
            </div>
            <h2 className="text-xl font-bold mb-2" style={{ color: '#1A1F36' }}>{t("slogan.thankYou")}</h2>
            <p className="text-sm text-gray-500 leading-relaxed mb-6">
              {t("slogan.sloganSuccess")}
            </p>
            <button
              onClick={() => { setShowPopup(false); navigate("/"); }}
              className="w-full text-white py-3 rounded-xl text-sm font-semibold shadow-md active:scale-95 transition-transform"
              style={{ backgroundColor: '#1A1F36' }}
            >
              {t("slogan.goHome")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}